import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    View,
    Text,
    ActivityIndicator,
    StyleSheet
} from 'react-native'

import { dateRangeFormat } from '../../lib/index'
import STYLES from '../../constants/styles'

export default class LoadingCard extends Component {
    static propTypes = {
        cardStyle: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        offsetKeyDate: PropTypes.object
    }

    render() {
        let { cardStyle, offsetKeyDate } = this.props

        return (
            <View style={[styles.container, cardStyle]}>
                <ActivityIndicator size={'large'} color={'#FF009B'}
                    style={{ marginBottom: 10 }} />

                {offsetKeyDate && <Text style={styles.cardText}>
                    Loading Transactions for {'\n'}
                    {dateRangeFormat(offsetKeyDate)}
                </Text>}

                {!offsetKeyDate && <Text style={styles.cardText}>
                    Loading Transactions ...
                </Text>}
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: STYLES.CARD_BACKGROUND_COLOR
        , borderWidth: 2
        , borderColor: 'white'
        , borderRadius: 20
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
        , shadowColor: STYLES.SHADOW_COLOR
        , shadowRadius: 40
        , shadowOffset: { width: 4, height: 6 }
    },
    loading: {
        marginBottom: 10
    },
    cardText: {
        fontSize: 16
        , fontWeight: 'bold'
        , textAlign: 'center'
        , color: STYLES.PRIMARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/components/cardLoading/index.js